import router from '@/utils/router'
import store from './store'
import { getLocal, removeLocal } from '@/utils/globalState'
router.beforeEach((to, from, next) => {
  const fullPath = to.fullPath
  const token = getLocal('token')
  // 當path 尾巴有 / 自動去除
  if (fullPath !== '/' && fullPath.lastIndexOf('/') === fullPath.length - 1) {
    next({ path: fullPath.substr(0, fullPath.length - 1) })
    return
  }
  if (token === null) {
    if (fullPath !== '/login') {
      location.hash = `/login`
      location.reload()
    } else {
      next()
    }
  } else {
    if (store.getters.storeInfo) {
      next()
    } else {
      store.dispatch('GetInfo').then(res => {
        if (res.result !== 'OK') { // res.code==='3015'
          // token過期 重新登入
          removeLocal('token')
          location.hash = `/login`
          location.reload()
        } else {
          const site = res.data.SITE
          // 取店家資訊
          store.dispatch('GetStoreList', site).then(res2 => {
            // console.log('res2==')
            // console.log(res2)
            // 取siteConfig
            store.dispatch('GetSiteConfig', site).then(res3 => {
              next()
            })
          }).catch((e) => {
            // 登入失敗清除cookie
            store.dispatch('LogOut').then(() => {
              // alert('驗證失敗 請重新登入')
              setTimeout(() => {
                // location.reload()
              }, 1000)
            })
          })
        }
      }).catch((e) => {
        // 登入失敗清除cookie
        store.dispatch('LogOut').then(() => {
          alert('驗證失敗 請重新登入')
          setTimeout(() => {
            // location.reload()
          }, 1000)
        })
      })
    }
  }
})
router.afterEach((to, from) => {
})
